export default {"src":"/_next/static/media/arrow-left.51d5c19f.svg","height":20,"width":12};